import { Microfrontend } from '@cian/mf-react';
import { IMicrofrontendManifest } from '@cian/mf-registry/shared';
import * as React from 'react';

import { useFiltersUpdatedEvent, useSaveSearchModal } from './hooks';
import { useApplicationContext } from '../ApplicationContext';

export const DesktopFiltersMicrofrontend: React.FC = () => {
  const { config } = useApplicationContext();

  const manifest = config.get<IMicrofrontendManifest | null>('desktopFiltersMicrofrontendManifest');

  useFiltersUpdatedEvent();

  useSaveSearchModal();

  return (
    <>
      {manifest && (
        <Microfrontend
          name={manifest.microfrontendName}
          image={manifest.imageVersion}
          runtime={manifest.runtimeName}
          instance={manifest.instanceId}
        />
      )}
    </>
  );
};
